import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Home from './pages/Home';
import Auth from './pages/Auth';
import CustomerDashboard from './pages/CustomerDashboard';
import CleanerDashboard from './pages/CleanerDashboard';
import SearchResults from './pages/SearchResults';
import CleanerProfilePage from './pages/CleanerProfilePage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import AdminDashboard from './pages/AdminDashboard';
import Contact from './pages/Contact';
import CheckrMock from './pages/CheckrMock';
import TrustSafety from './pages/legal/TrustSafety';
import Privacy from './pages/legal/Privacy';
import Terms from './pages/legal/Terms';
import Refund from './pages/legal/Refund';
import CookieConsent from './components/CookieConsent';
import AssistantChat from './components/AssistantChat';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';
import { useReferralTracker, usePromoTracker } from './hooks/useReferralTracker';
import './App.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useReferralTracker();
  usePromoTracker();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        setUser(res.data);
        setLoading(false);
      }).catch(() => {
        localStorage.removeItem('token');
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg text-text-secondary">Loading...</div>
      </div>
    );
  }

  const getDashboardPath = (u) => {
    if (!u) return '/auth';
    if (u.role === 'admin') return '/dashboard/admin';
    if (u.role === 'cleaner') return '/dashboard/cleaner';
    return '/dashboard/customer';
  };

  return (
    <LanguageProvider>
      <BrowserRouter>
        <CookieConsent />
        <AssistantChatWithT />
        <Routes>
        <Route path="/" element={<Home user={user} setUser={setUser} />} />
        <Route path="/auth" element={user ? <Navigate to={getDashboardPath(user)} /> : <Auth setUser={setUser} />} />
        <Route path="/search" element={<SearchResults user={user} />} />
        <Route path="/cleaner/:cleanerId" element={<CleanerProfilePage user={user} />} />
        <Route path="/dashboard/customer" element={user?.role === 'customer' ? <CustomerDashboard user={user} setUser={setUser} /> : <Navigate to="/auth" />} />
        <Route path="/dashboard/cleaner" element={user?.role === 'cleaner' ? <CleanerDashboard user={user} setUser={setUser} /> : <Navigate to="/auth" />} />
        <Route path="/dashboard/admin" element={user?.role === 'admin' ? <AdminDashboard user={user} setUser={setUser} /> : <Navigate to="/auth" />} />
        <Route path="/payment-success" element={<PaymentSuccess user={user} />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/contact" element={<Contact user={user} setUser={setUser} />} />
        <Route path="/checkr-mock" element={<CheckrMock user={user} setUser={setUser} />} />
        <Route path="/trust-safety" element={<TrustSafety user={user} setUser={setUser} />} />
        <Route path="/privacy-policy" element={<Privacy user={user} setUser={setUser} />} />
        <Route path="/terms-of-service" element={<Terms user={user} setUser={setUser} />} />
        <Route path="/refund-policy" element={<Refund user={user} setUser={setUser} />} />
      </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

const AssistantChatWithT = () => {
  const { t } = useLanguage();
  return <AssistantChat t={t} />;
};

export default App;
